import { post } from "./api";

const marketplaceUrl = process.env.REACT_APP_MARKETPLACE_ROOT_URL;
const generalTermsFile = `${marketplaceUrl}/General-rental-terms-for-motorhomes-and-campers.pdf`;

export const messageAfterRegister = `Welcome to ${marketplaceUrl}! We\'re excited that you\'ve created a profile. You can now easily rent or list campers and motorhomes in our beautiful country. If you need help, we\'re here for you. Happy renting!`;
export const messageAfterListingPublish = `Your motorhome is now live on ${marketplaceUrl}! You will start receiving inquiries from potential renters. Remember to respond quickly to maximize your rental opportunities. Best of luck!`;
export const messageAfterCheckoutConfirmPayment = (dispayName) => `You\'ve received a rental request from ${dispayName}! Log in to ${marketplaceUrl} to view the request and respond as soon as possible.`;
export const messageAfterOfferAccept = `Congratulations, your rental request has been approved! You can now complete the booking on ${marketplaceUrl}. Don\'t forget to pay the deposit during the check-in process.`;
export const messageAfterOfferDecline = `Unfortunately, your rental request has been declined. Please check other available vehicles on ${marketplaceUrl}.`;
export const messageAfterCheckInCompletedCustomer = (displayName) => `Your booking is confirmed! Here\'s the contact info for owner: ${displayName}. Please arrange pickup. You can find all booking details in this PDF: ${generalTermsFile}. We\'ve also set up a WhatsApp group for easier communication.`;
// export const messageAfterCheckInCompletedCustomer = (displayName, orderId) => `Your booking is confirmed! Here\'s the contact info for owner: ${displayName}. Please arrange pickup. You can find all booking details at: ${marketplaceUrl}/order/${orderId}. We\'ve also set up a WhatsApp group for easier communication.`;
export const messageAfterCheckInCompletedProvider = (displayName) => `Your booking is confirmed! Here\'s the contact info for renter: ${displayName}. Please arrange drop-off. You can find all booking details in this PDF: ${generalTermsFile}. We\'ve also set up a WhatsApp group for easier communication.`;
// export const messageAfterCheckInCompletedProvider = (displayName, orderId) => `Your booking is confirmed! Here\'s the contact info for renter: ${displayName}. Please arrange drop-off. You can find all booking details at: ${marketplaceUrl}/sale/${orderId}. We\'ve also set up a WhatsApp group for easier communication.`;
const messageAfterSendMessage = (name) => `You have a new message from ${name} on ${marketplaceUrl}. Login to respond.`;

//implemented on AuthenticationPage, in handleSubmitSignup
export const sendSmsOnRegister = (phoneNumber) => {
    const message = messageAfterRegister;
    return post('/api/send-sms-to-phoneNumber', { phoneNumber, message });
}

//implemented on EditListingWizard, in handlePublishListing
export const sendSmsAfterListingPublish = (userId) => {
    const message = messageAfterListingPublish;
    return post('/api/send-sms-to-user', { userId, message });
}

//implemented on CheckoutPage redux, after confirm payment success
export const sendSmsAfterCheckoutConfirmPayment = (userId, dispayName) => {
    const message = messageAfterCheckoutConfirmPayment(dispayName);
    return post('/api/send-sms-to-user', { userId, message });
}

//implemented on TransactionPage redux, after confirm order accept
export const sendSmsAfterOfferAccept = (userId) => {
    const message = messageAfterOfferAccept;
    return post('/api/send-sms-to-user', { userId, message, });
}

//implemented on TransactionPage redux, after confirm order decline
export const sendSmsAfterOfferDecline = (userId) => {
    const message = messageAfterOfferDecline;
    return post('/api/send-sms-to-user', { userId, message, })
        .catch(e => {
            console.error(`Failed to send decline SMS: ${e.message}`);
        });
}
export const sendSmsAfterSendMessage = (userId, name) => {
    const message = messageAfterSendMessage(name);
    return post('/api/send-sms-to-user', { userId, message, })
        .catch(e => {
            console.error(`Failed to send decline SMS: ${e.message}`);
        });
}

//implemented on TransactionPage redux, after check-in completed
export const sendSmsAfterCheckInCompleted = (customer, provider, orderId) => {
    // Send SMS to the customer
    const sendToCustomer = post('/api/send-sms-to-user', { userId: customer.id, message: messageAfterCheckInCompletedCustomer(provider.displayName, orderId) })
        .catch(e => {
            console.error(`Failed to send check-in completed SMS to customer: ${e.message}`);
        });

    // Send SMS to the provider
    const sendToProvider = post('/api/send-sms-to-user', { userId: provider.id, message: messageAfterCheckInCompletedProvider(customer.displayName, orderId) })
        .catch(e => {
            console.error(`Failed to send check-in completed SMS to provider: ${e.message}`);
        });

    // Return both promises
    return Promise.all([sendToCustomer, sendToProvider]);
};

// export const sendSmsOnRegister = (currentUser) => {
//     const userId = currentUser.id.uuid;
//     const message = messageAfterRegister;

//     return post('/api/sens-sms-to-user', {
//         userId, message
//     });
// }

